import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,707.040389 L1920,1419.44309 C1919.89621,1525.20334 1835.41256,1611.24381 1731.62429,1611.24381 C1627.73223,1611.24381 1543.35236,1525.09955 1543.35236,1419.13172 C1543.35236,1313.1639 1627.73223,1226.91584 1731.62429,1226.91584 C1762.24183,1226.91584 1790.7836,1235.01133 1816.21173,1248.29623 L1816.21173,1248.29623 L1816.21173,846.012885 L1374.17748,976.786108 L1374.17748,1580.83385 L1373.34717,1580.83385 C1368.98806,1682.85772 1286.89154,1764.64288 1185.90555,1764.64288 C1082.01349,1764.64288 997.529839,1678.49861 997.529839,1572.427 C997.529839,1466.56296 1082.01349,1380.31491 1185.90555,1380.31491 C1216.4193,1380.31491 1244.85729,1388.41039 1270.38921,1401.69529 L1270.38921,1401.69529 L1270.38921,899.256269 L1920,707.040389 Z M0.207576544,244.954245 C704.51479,44.7466685 1351.01194,245.058033 1351.01194,245.058033 L1351.01194,245.058033 L1351.01194,725.597732 L1149.03996,786.313871 L1149.03996,1246.30349 C527.970939,1362.1312 0,1199.91014 0,1199.91014 L0,1199.91014 L0,245.058033 Z M541.774779,480.761199 L541.774779,976.76535 L752.56876,852.738365 L963.466528,728.815169 L752.56876,604.684396 L541.774779,480.761199 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAttachMediaSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAttachMediaSolid, _Component);

  var _super = _createSuper(IconAttachMediaSolid);

  function IconAttachMediaSolid() {
    _classCallCheck(this, IconAttachMediaSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAttachMediaSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAttachMedia",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAttachMediaSolid.displayName = "IconAttachMediaSolid";
  return IconAttachMediaSolid;
}(Component);

IconAttachMediaSolid.glyphName = 'attach-media';
IconAttachMediaSolid.variant = 'Solid';
IconAttachMediaSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAttachMediaSolid;
export { IconAttachMediaSolid };